<template>
  <el-container :class="{'mobile': ismobile }" :width="diaWidth" style="text-align: center">
    <div class="moduleTitle">
      <div class="text">{{ $t(pageTitle) }}</div>
    </div>
    <div id="google" @click="googleClickAction" class='width50 module'>
      <div class="button">
        <img src="/static/img/login/google.png" class="icon"/>
        <span class="title">{{ $t('Google') }}</span>
      </div>
    </div>
    <div id="facebook" v-if="facebookShow" @click="facebookClickAction" class='width50 module'>
      <div class="button">
        <img src="/static/img/login/facebook.png"/>
        <span class="title">{{ $t('Facebook') }}</span>
      </div>
    </div>
    <div id="apple" v-if="appleShow" @click="appleClickAction" class='width50 module'>
      <div class="button">
        <img src="/static/img/login/apple.png"/>
        <span class="title">{{ $t('Apple') }}</span>
      </div>
    </div>
    <div id="wechat" v-if="site !== 'us' && (this.common.isWechat() === true || this.common.isMobile() === false)" @click="wechatClickAction" class='width50 module'>
      <div class="button">
        <img src="/static/img/login/wechat.png"/>
        <span class="title">{{ $t('wechat') }}</span>
      </div>
    </div>
  </el-container>
</template>

<script>
import { authorizedLogin } from '@/request/login.js'

export default {
  name: 'authorizedLoginModule',
  props: ['pageTitle'],
  components: {
    authorizedLogin
  },
  data () {
    return {
      ismobile: this.common.isMobile(),
      diaWidth: '95%',
      currency: this.common.currencySet(this),
      language: this.common.languageSet(this),
      facebookShow: true,
      appleShow: this.isApple(),
      site: this.getSite(),
      source: 'roompai',
      conver: ''
    }
  },
  watch: {},
  created () {
  },
  mounted () {
    if (document.documentElement.clientWidth < 1001) {
      this.ismobile = true
      this.diaWidth = '95%'
    } else {
      this.ismobile = false
      this.diaWidth = '500px'
    }
    // 存储来源
    var source = this.common.linkQuerys.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
    var conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
    // 根据三方授权数量处理按钮宽度.
    if (document.getElementsByClassName('module').length % 2 === 1) {
      document.getElementsByClassName('module')[0].className = 'module width100'
    }
    // 微信扫码成功跳转页面处理code参数.
    if (this.$route.query.code !== undefined && this.$route.query.appid !== undefined) {
      this.wechatCallback(this.$route.query)
    }
    // google授权成功处理.
    if (this.common.linkQuerys.google_access_token !== undefined) {
      this.googleCallback(this.common.linkQuerys.google_access_token)
    }
    // facebook授权成功处理.
    if (this.common.linkQuerys.facebook_access_token !== undefined) {
      this.facebookCallback(this.common.linkQuerys.facebook_access_token)
    }
    // apple授权成功处理.
    if (this.common.linkQuerys.apple_access_token !== undefined) {
      this.appleCallback(this.common.linkQuerys.apple_access_token)
    }
  },
  methods: {
    setOptionWidth (event) {
      if (this.ismobile === true) {
        this.selectOptionWidth = event.view.innerWidth * 0.95 - 40
      }
    },
    getSite () {
      let site = 'www'
      if (location.host === 'www.roompai.com' || location.host === 'test.roompai.com') {
        site = 'www'
      } else if (location.host === 'us.roompai.com' || location.host === 'test.us.roompai.com') {
        site = 'us'
      }
      return site
    },
    isApple () {
      return true
    },
    wechatClickAction () {
      if (this.ismobile === false) {
        // 新窗口居中.
        var iWidth = 500
        var iHeight = 500
        var iTop = (window.screen.height - 30 - iHeight) / 2
        var iLeft = (window.screen.width - 10 - iWidth) / 2
        window.open(this.common.getWechatPcAuthorizationUrl(this.$i18n.locale), '_blank', 'width=' + iWidth + ',height=' + iHeight + ',top=' + iTop + ',left=' + iLeft)
        window.wechatInstanceCallback = this.wechatCallback
      } else if (this.common.isWechat() === true) {
        window.location.href = this.common.getWechatMobileAuthorizationUrl()
      }
    },
    googleClickAction () {
      if (this.ismobile === false) {
        var iWidth = 500
        var iHeight = 400
        var iTop = (window.screen.height - 30 - iHeight) / 2
        var iLeft = (window.screen.width - 10 - iWidth) / 2
        window.open(this.common.getGoogleAuthorizationUrl(this.$i18n.locale), '_blank', 'width=' + iWidth + ',height=' + iHeight + ',top=' + iTop + ',left=' + iLeft)
        window.googleInstanceCallback = this.googleCallback
      } else {
        window.location.href = this.common.getGoogleAuthorizationUrl()
      }
    },
    facebookClickAction () {
      console.log('facebook click')
      if (this.ismobile === false) {
        var iWidth = 700
        var iHeight = 700
        var iTop = (window.screen.height - 30 - iHeight) / 2
        var iLeft = (window.screen.width - 10 - iWidth) / 2
        window.open(this.common.getFacebookAuthorizationUrl(this.$i18n.locale), '_blank', 'width=' + iWidth + ',height=' + iHeight + ',top=' + iTop + ',left=' + iLeft)
        window.facebookInstanceCallback = this.facebookCallback
      } else {
        window.location.href = this.common.getFacebookAuthorizationUrl()
      }
    },
    appleClickAction () {
      console.log('apple click')
      if (this.ismobile === false) {
        var iWidth = 700
        var iHeight = 700
        var iTop = (window.screen.height - 30 - iHeight) / 2
        var iLeft = (window.screen.width - 10 - iWidth) / 2
        let appleUrl = this.common.getAppleAuthorizationUrl(this.$i18n.locale)
        let appleConfirmUrl = this.$router.resolve({ name: 'appleConfirm' }).href + '?appleAuthUrl=' + encodeURIComponent(appleUrl)
        window.open(appleConfirmUrl, '_blank', 'width=' + iWidth + ',height=' + iHeight + ',top=' + iTop + ',left=' + iLeft)
        window.appleInstanceCallback = this.appleCallback
      } else {
        window.location.href = this.common.getAppleAuthorizationUrl()
      }
    },
    wechatCallback (data) {
      var newQuerys = ''
      var LoginWebsiteAddress = sessionStorage.getItem('LoginWebsiteAddress')
      var sessionid = this.common.sessionidGet(this)
      var searchHotelLocation = sessionStorage.getItem('search_hotel_location')
      let requestDataJson = {
        'code': data.code,
        'appid': data.appid,
        'time': parseInt(new Date().getTime() / 1000),
        'sessionid': sessionid,
        'operation': 'Wechat',
        'language': this.language,
        'site': this.site,
        'source': this.source,
        'searchHotelLocation': searchHotelLocation !== null ? searchHotelLocation : ''
      }
      let requestData = this.common.encryptionData(requestDataJson, this)
      authorizedLogin(requestData).then(res => {
        console.log(res)
        if (res.flag === '200' || res.flag === '201') {
          localStorage.setItem('token', res.data.token)
          if (LoginWebsiteAddress !== null && LoginWebsiteAddress.indexOf('login/login') === -1) {
            window.document.location.href = LoginWebsiteAddress
          } else {
            if (this.source === 'roompai') {
              if (this.conver === 1 || this.conver === '1') {
                newQuerys = this.common.linkEncode({'conver': this.conver}, 'obj')
                this.$router.push({name: 'Home', params: {'querys': newQuerys}})
              } else {
                this.$router.push({name: 'Home'})
              }
            } else {
              newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
              if (this.conver === 1 || this.conver === '1') {
                newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
              }
              this.$router.push({name: 'Home', params: {'querys': newQuerys}})
            }
          }
        } else if (res.flag === '102' || res.flag === '103') {
          this.$message({
            type: 'error',
            message: this.$t(res.msg)
          })
        }
      })
    },
    googleCallback (accessToken) {
      var newQuerys = ''
      let requestTime = parseInt(new Date().getTime())
      let time = parseInt(requestTime / 1000)
      let sessionid = this.common.sessionidGet(this)
      let searchHotelLocation = sessionStorage.getItem('search_hotel_location')
      let requestDataJson = {
        'access_token': accessToken,
        'time': time,
        'sessionid': sessionid,
        'operation': 'Google',
        'language': this.language,
        'site': this.site,
        'source': this.source,
        'searchHotelLocation': searchHotelLocation !== null ? searchHotelLocation : ''
      }
      let requestData = this.common.encryptionData(requestDataJson, this)
      authorizedLogin(requestData).then(res => {
        console.log(res)
        if (res.flag === '200' || res.flag === '201') {
          localStorage.setItem('token', res.data.token)
          var LoginWebsiteAddress = sessionStorage.getItem('LoginWebsiteAddress')
          if (res.data.riskLevelMedium === '1') {
            sessionStorage.setItem('BindMobileWebsiteAddress', LoginWebsiteAddress)
            this.$message({
              type: 'error',
              message: this.$t(res.msg)
            })
            setTimeout(() => {
              newQuerys = this.common.linkEncode({'source': this.source, 'bindMobile': '1', 'type': 'user'}, 'obj')
              if (this.conver === 1 || this.conver === '1') {
                newQuerys = this.common.linkEncode({'source': this.source, 'bindMobile': '1', 'type': 'user', 'conver': this.conver}, 'obj')
              }
              this.$router.push({name: 'myAccount', params: {'querys': newQuerys}})
            }, 1000)
            return ''
          }
          if (LoginWebsiteAddress !== null && LoginWebsiteAddress.indexOf('login/login') === -1) {
            window.document.location.href = LoginWebsiteAddress
          } else {
            if (this.source === 'roompai') {
              if (this.conver === 1 || this.conver === '1') {
                newQuerys = this.common.linkEncode({'conver': this.conver}, 'obj')
                this.$router.push({name: 'Home', params: {'querys': newQuerys}})
              } else {
                this.$router.push({name: 'Home'})
              }
            } else {
              newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
              if (this.conver === 1 || this.conver === '1') {
                newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
              }
              this.$router.push({name: 'Home', params: {'querys': newQuerys}})
            }
          }
        } else if (res.flag === '102' || res.flag === '103') {
          this.$message({
            type: 'error',
            message: this.$t(res.msg)
          })
        }
      })
    },
    facebookCallback (accessToken) {
      var newQuerys = ''
      let requestTime = parseInt(new Date().getTime())
      let time = parseInt(requestTime / 1000)
      let sessionid = this.common.sessionidGet(this)
      let searchHotelLocation = sessionStorage.getItem('search_hotel_location')
      let requestDataJson = {
        'access_token': accessToken,
        'time': time,
        'sessionid': sessionid,
        'operation': 'FaceBook',
        'language': this.language,
        'site': this.site,
        'source': this.source,
        'searchHotelLocation': searchHotelLocation !== null ? searchHotelLocation : ''
      }
      let requestData = this.common.encryptionData(requestDataJson, this)
      authorizedLogin(requestData).then(res => {
        console.log(res)
        if (res.flag === '200' || res.flag === '201') {
          localStorage.setItem('token', res.data.token)
          let LoginWebsiteAddress = sessionStorage.getItem('LoginWebsiteAddress')
          if (res.data.riskLevelMedium === '1') {
            sessionStorage.setItem('BindMobileWebsiteAddress', LoginWebsiteAddress)
            this.$message({
              type: 'error',
              message: this.$t(res.msg)
            })
            setTimeout(() => {
              newQuerys = this.common.linkEncode({'source': this.source, 'bindMobile': '1', 'type': 'user'}, 'obj')
              if (this.conver === 1 || this.conver === '1') {
                newQuerys = this.common.linkEncode({'source': this.source, 'bindMobile': '1', 'type': 'user', 'conver': this.conver}, 'obj')
              }
              this.$router.push({name: 'myAccount', params: {'querys': newQuerys}})
            }, 1000)
            return ''
          }
          if (LoginWebsiteAddress !== null && LoginWebsiteAddress.indexOf('login/login') === -1) {
            window.document.location.href = LoginWebsiteAddress
          } else {
            if (this.source === 'roompai') {
              if (this.conver === 1 || this.conver === '1') {
                newQuerys = this.common.linkEncode({'conver': this.conver}, 'obj')
                this.$router.push({name: 'Home', params: {'querys': newQuerys}})
              } else {
                this.$router.push({name: 'Home'})
              }
            } else {
              newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
              if (this.conver === 1 || this.conver === '1') {
                newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
              }
              this.$router.push({name: 'Home', params: {'querys': newQuerys}})
            }
          }
        } else if (res.flag === '102' || res.flag === '103') {
          this.$message({
            type: 'error',
            message: this.$t(res.msg)
          })
        }
      })
    },
    appleCallback (accessToken) {
      var newQuerys = ''
      let requestTime = parseInt(new Date().getTime())
      let time = parseInt(requestTime / 1000)
      let sessionid = this.common.sessionidGet(this)
      let searchHotelLocation = sessionStorage.getItem('search_hotel_location')
      let requestDataJson = {
        'access_token': accessToken,
        'time': time,
        'sessionid': sessionid,
        'operation': 'Apple',
        'language': this.language,
        'site': this.site,
        'source': this.source,
        'searchHotelLocation': searchHotelLocation !== null ? searchHotelLocation : ''
      }
      let requestData = this.common.encryptionData(requestDataJson, this)
      authorizedLogin(requestData).then(res => {
        console.log(res)
        if (res.flag === '200' || res.flag === '201') {
          localStorage.setItem('token', res.data.token)
          let LoginWebsiteAddress = sessionStorage.getItem('LoginWebsiteAddress')
          if (res.data.riskLevelMedium === '1') {
            sessionStorage.setItem('BindMobileWebsiteAddress', LoginWebsiteAddress)
            this.$message({
              type: 'error',
              message: this.$t(res.msg)
            })
            setTimeout(() => {
              newQuerys = this.common.linkEncode({'source': this.source, 'bindMobile': '1', 'type': 'user'}, 'obj')
              if (this.conver === 1 || this.conver === '1') {
                newQuerys = this.common.linkEncode({'source': this.source, 'bindMobile': '1', 'type': 'user', 'conver': this.conver}, 'obj')
              }
              this.$router.push({name: 'myAccount', params: {'querys': newQuerys}})
            }, 1000)
            return ''
          }
          if (LoginWebsiteAddress !== null && LoginWebsiteAddress.indexOf('login/login') === -1) {
            window.document.location.href = LoginWebsiteAddress
          } else {
            if (this.source === 'roompai') {
              if (this.conver === 1 || this.conver === '1') {
                newQuerys = this.common.linkEncode({'conver': this.conver}, 'obj')
                this.$router.push({name: 'Home', params: {'querys': newQuerys}})
              } else {
                this.$router.push({name: 'Home'})
              }
            } else {
              newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
              if (this.conver === 1 || this.conver === '1') {
                newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
              }
              this.$router.push({name: 'Home', params: {'querys': newQuerys}})
            }
          }
        } else if (res.flag === '102' || res.flag === '103') {
          this.$message({
            type: 'error',
            message: this.$t(res.msg)
          })
        }
      })
    }
  },
  computed: {}
}
</script>

<style scoped>
.moduleTitle {
  width: 100%;
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  text-align: center;
  background-image:url(/static/img/login/line.svg);
  background-repeat:repeat-x;
  background-position: center;
}
.moduleTitle .text {
  display: inline-block;
  background: #ffffff;
  padding: 0 10px;
}
.width50 { width: 49%;margin: 5px 0 !important;}
.width100 { width: 100%;margin: 5px 0 !important;}
.module {
  display: inline-block;
  height: 44px;
  margin: 5px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(221, 223, 226, 1);
  border-radius: 6px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;;
  text-align: center;
  background-position: center;
}

.module .button {
  line-height: 42px;
  border: none;
  vertical-align: middle;
}
.module .button:hover {
  cursor: pointer;
}
.module .button img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.module .button .title {
  background: inherit;
  background-color: rgba(255, 255, 255, 0);
  border: 0px none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-family: 'HelveticaNeue-Medium', 'Helvetica Neue Medium', 'Helvetica Neue', sans-serif;
  font-weight: 500;
  color: #609AF9;
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/components/login/module/authorizedLogin.vue